export const DEFAULT_CONTACT_EMAIL = "info@tvarkarastis.com";
